// extracted by mini-css-extract-plugin
export default {"confirmation":"CompletePaid_confirmation__048Os","buttonGrid":"CompletePaid_buttonGrid__rLa2m"};